<template>
    <div class="container battle-info border border-dark rounded my-1">
        <div class="d-flex justify-content-center">
            <div class="row">
                <div class="col-5">
                    {{this.name1}}
                </div>
                <div class="col-2">VS</div>
                <div class="col-5">
                    {{this.name2}}
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center" v-if="this.pokemon1 && this.pokemon2">
            <div class="row">
                <div class="col-6">
                    <BattleInfo :pvp="pvp" :attacker="this.pokemon1" :defender="this.pokemon2" :update="updatex"/>
                </div>
                <div class="col-6">
                    <BattleInfo :pvp="pvp" :attacker="this.pokemon2" :defender="this.pokemon1" :update="updatex"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {pokemon_data} from "../../helpers/pokemon_data";
    import BattleInfo from "./battle/BattleInfo";


    export default {
        name: "PokemonBattleInfo",
        components: {BattleInfo},
        props: ['pokemon1', 'pokemon2','pvp','updatex'],
        computed: {
            name1: function () {
                if (this.pokemon1 == null) return "";
                if (this.pokemon1.id === undefined) return "";
                return pokemon_data[this.pokemon1.id][0];
            },
            name2: function () {
                if (this.pokemon2 == null) return "";
                if (this.pokemon2.id === undefined) return "";
                return pokemon_data[this.pokemon2.id][0];
            }
        }
    }
</script>

<style scoped>
    .battle-info {

    }
</style>